import axios from "axios";
import Cookies from 'js-cookie';
import Constants from '../Utilities/Constants';
import { v4 as uuidv4 } from 'uuid';

const GetCustomer = async ({setCustomer, setCart, setCartId, enrichProduct}) => {
    const customerid = Cookies.get('customerid');

    if (customerid) {
        FetchCustomer(customerid).then(data => setCustomer(data));
        FetchCart(customerid, enrichProduct).then(data => setCart(data));
        setCartId(customerid);
    }
    else {
        var cartid = Cookies.get('localCartId');

        if (!cartid) {
            cartid = uuidv4();
            Cookies.set('localCartId',cartid);
        }
        FetchCart(cartid, enrichProduct).then(data => setCart(data));
        setCartId(cartid);
        setCustomer(null);
    }
}

const FetchCustomer = async (customerid) => {
    const url = `${Constants.API_URL_GET_CUSTOMER}/?id=${customerid}`;
    try {
        const response = await axios.get(url);
        return response.data;
    }
    catch(err) {
        console.error('Cannot read customer', err);
        return null;
    }
}

const FetchCart = async (cartid, enrichProduct) => {
    const url = `${Constants.API_URL_GET_CART}/${cartid}`;
    try {
        const response = await axios.get(url);
        
        if (enrichProduct) {
            // Enrich each cart item's product
            const enrichedCart = response.data.map(cartItem => {
                
                // Since this is a cart item, create a mock cart array with just this item
                // so enrichProduct can determine the active unit correctly
                const mockCart = [{
                    productId: cartItem.product.id,
                    unitId: cartItem.unitId
                }];
                
                // Enrich the product with cart context
                const enrichedProduct = enrichProduct(cartItem.product, mockCart);
                
                // Return cart item with enriched product
                return {
                    ...cartItem,
                    product: enrichedProduct
                };
            });
            
            return enrichedCart;
            
        } else {
            return response.data;
        }
    }
    catch(err) {
        console.error('Cannot read cart', err);
        return [];
    }
}

export default GetCustomer;